import wire from '../wire';
import template from './bulk-import.html';
import Controller from './bulk-import-controller';

var module = wire('bulk-import', template, Controller, 'BulkImportController');

export default module;



// WEBPACK FOOTER //
// ./app/pages/bulk-import/_index.js